import React from 'react';

function FormattedDate({ date, className }) {
  const dateObj = new Date(date);

  const formatted = dateObj.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const finalString = formatted
    .replace(' г.', '') 
    .replace(',', ' г.,');

  return <span className={className}>{finalString}</span>;
}

export default FormattedDate;